import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";

import TestimonialImage from "../../../../../assets/images/png/courses/course-testimonial.webp";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/trainers pictures/abolanle1.webp";
import IdaraImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/Idara Suit -  Data School Support Person.png";
import RachaelImage from "../../../../../assets/images/png/courses/instructors/rachael.webp";
import DoluImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/Ayotunde1.webp";
import FaithImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/FAITH Customer Success Manager.png";

import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/bilikis.webp";
import Testimony1 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/ismail.webp";
import Testimony4 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/vincent.webp";

import OladimejiImage from "../../../../../assets/images/png/courses/testimonies/oladimeji.png";
import LyndaImage from "../../../../../assets/images/png/courses/testimonies/lynda.png";
import RasheedatImage from "../../../../../assets/images/png/courses/testimonies/rasheedat.png";
import FavourImage from "../../../../../assets/images/png/courses/testimonies/favour.png";
import IjeaomaImage from "../../../../../assets/images/png/courses/testimonies/ijeaomo.png";
import TopeImage from "../../../../../assets/images/png/courses/testimonies/tope.png";
import IyereImage from "../../../../../assets/images/png/courses/testimonies/iyere.png";
import OlumideImage from "../../../../../assets/images/png/courses/testimonies/olumide.png";
import KingsleyImage from "../../../../../assets/images/png/courses/testimonies/kingsley.png";
import AjinifesinImage from "../../../../../assets/images/png/courses/testimonies/ajinifesin.png";
import TemioluwaImage from "../../../../../assets/images/png/courses/testimonies/temioluwa.png";
import BashirImage from "../../../../../assets/images/png/courses/testimonies/bashir.png";
import FunmilolaImage from "../../../../../assets/images/png/courses/testimonies/funmilola.png";
import AdeniyiImage from "../../../../../assets/images/png/courses/testimonies/adeniyi.png";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/data.webp";
import PortfolioUserAvatar from "../../../../../assets/images/png/courses/portfolio/patrick.jpeg";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import DataAnalyticsPreview from "../../../../../assets/images/jpeg/dataAnalysisPreview.jpeg";

export const dataAcceleratorAfrica = {
  id: 1,
  tag: "FOR DATA ENTHUSIAST",
  title: "Data Analytics Bootcamp",
  seoTitle: "Data Analytics Bootcamp Nigeria | Become a Data Analyst",
  description: `
  The Data Analytics Bootcamp program of the Data School is designed to help data enthusiast learn 
  the analytics and data strategy, bringing the value of Big Data Analytics to your current role.
    `,
  metatags: `Learn data analytics with Excel, SQL, Power BI, and Tableau. Get job-ready in 12 weeks with Utiva's hands-on, mentor-led data analytics bootcamp in Nigeria.`,
  duration: "3 Months",

  downloadBrochureUrl:
    "https://drive.google.com/file/d/188697Xx6dqHDTUfaJO-ZuX7lvWVfjUus/view?usp=sharing",

  courseFormUrl: "courses/data-analytics-bootcamp/fill-form",

  jobTitle: "Data Analyst",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    image: TestimonialImage,
    name: "Adedoja Desh",
    role: "Data Fellow",
    testimony: `
    I was looking for something a little more than a training, a school I 
    could count on for my continuous skill and professional development. 
    Utiva kept coming up so I jumped in. I went through the Data Analytics 
    bootcamp and then the ‘Big Data with Python’ program. 
    I am now a Data Scientist and Consultant. Mayowa Hambolu — Data Fellow`,
    starRating: "4.6",
    date: "August 2021",
  },

  courseOverview: {
    title: `Learn Data Analytics Best Practices Live, Led by Experienced Data Analyst and move on to New Roles in Tech`,
    desc: `
    The Utiva's Data Analytics bootcamp is a specialized 
    course that is designed to introduce learners to Data 
    Analytics from the foundation to advanced knowledge. 
    This program is taught and led by industry experts and 
    leaders, the course uses a project-based learning model 
    to provide hands-on experience with the latest data 
    concepts and tools. By the end of the course, professionals 
    will be confident in analysis, working 
    with databases, and creating visualizations.
    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Data Fundamentals",
      unitTag: "Excel, SQL and Power BI",
      unitDescription: `
      Launch your data analytics journey with an introduction to data by learning foundational concepts. 
      You'll start your learning journey by developing a problem-solving framework and by 
      understanding how data should be collected and prepared for data analysis. 
      Translate your learnings into job-ready skills by solving real-world 
      problems with a variety of data sets.
        `,
    },
    {
      unitId: 2,
      unitTitle: "Data Visualization & Communicating Data Insights",
      unitTag: "Data Analytics Process, Data Collection",
      unitDescription: `
      Begin your learning by discovering how to present actionable 
      insights effectively through data visualizations that 
      inform business decisions created with Power BI, the world's 
      leading business analytics platform. Go beyond simply presenting 
      analysis results by learning best practices in storytelling 
      with data and help drive effective decision-making informed 
      by real data insights.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Fundamentals of Data Visualization",
          featureDescription: `Learn the fundamentals of data visualization, know how 
          to import and transform different data sources into Power BI.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Build Interactive and Impactful Dashboards",
          featureDescription: `Master the skills to develop a communicative 
          data visualization, tailored to unique business 
          needs. Showcase your projects to blog posts, social media, and so on.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Convey Captivating Data Narratives",
          featureDescription: `Learn how to capture the attention of a broad audience, and create 
          visualizations that effectively communicate the value of your data analysis.`,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Database Management & Advanced Data Analytics",
      unitTag: "PostgreSQL",
      unitDescription: `
      Go beyond dashboards and get dirty with relational databases. 
      By learning how to use PostgreSQL - a tool mostly used by tech 
      companies like Uber, Instagram, Netflix, and more - you will be 
      able to understand how databases are constructed, learn how to 
      query, analyze complex data and 
      perform advanced operations analysis through real-life business cases. 
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Learn Database Fundamentals",
          featureDescription: `Understanding relational databases, schema, and 
          other key principles utilized by world data analysts are required to 
          perform and analyze large data sets and advanced data analysis..`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Manage and Analyze Data with SQL",
          featureDescription: `Explore the foundations of programming languages 
          and learn Structured Query Language (SQL) – a powerful programming 
          language and one of the essential programming skills for a career in data.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Organize and Optimize Data Sets",
          featureDescription: `Speed up your analysis and reduce complexity 
          by learning a systematic approach to normalize 
          data, along with important techniques for combining and sorting information.`,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Abolanle",
      coachRole: "Data Analytics Practice Lead",
    },
    {
      coachId: 2,
      coachImage: RachaelImage,
      coachName: "Rachael Wilson",
      coachRole: "Senior Data Analyst",
    },
    {
      coachId: 3,
      coachImage: DoluImage,
      coachName: "Doluwamu Ayotunde Solana",
      coachRole: "Senior Data Scientist",
    },
    {
      coachId: 4,
      coachImage: IdaraImage,
      coachName: "Idara",
      coachRole: "Data School Support Person",
    },
    {
      coachId: 5,
      coachImage: FaithImage,
      coachName: "Faith",
      coachRole: "Customer Success Manager",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Virtual Classes",
      modelDescription:
        "Join and collaborate with other students in Instructor-led virtual classes.",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Business Case-focused",
      modelDescription:
        "Work on real-life projects by applying what you learn to solve related business problems.",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Peer-to-peer Sessions",
      modelDescription:
        "Share knowledge with other fellows and gain multidimensional perspectives of problem-solving.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Virtual Project",
      modelDescription: `Work on multiple projects to improve your knowledge and 
        capacity by engaging and interacting with others.`,
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "https://www.linkedin.com/in/olowu-abayomi-896969101/",
      image: Testimony1,
      firstname: "Ismail",
      lastname: "Jimoh",
      company: "Banking Industry(FCMB)",
      testimony: `
      I joined the Utiva Data School because I needed to update my capacity in
      Data Analytics as well as reduce the turnaround time it takes me to deliver
      on my job role. It's been an awesome experience.
      `,
    },
    {
      id: 2,
      linkedIn: "",
      image: Testimony2,
      firstname: "Bilikis",
      lastname: "Ajiwokewu",
      company: "Operations Analyst, Enerwhere",
      testimony: `
      I was really excited about Utiva going virtual.
      Excited that I was able to learn from home. I believe in self-learning 
      but as a mother, I couldn't drive myself but Utiva was able to drive me to 
      discipline myself.  The team is highly organized and the community is amazing and interactive.
      `,
    },
    {
      id: 3,
      linkedIn: "",
      image: null,
      firstname: "Margaret",
      lastname: "Mbede",
      company: "Oil and Gas Industry",
      testimony: `
      The Utiva Data School is important for me because today, 
      I can boldly say I am a data analyst. Utiva has done really well 
      with me and for me, I am a better person. Bringing in financial 
      and Business Intelligence into the oil and gas space, when I came 
      to the conclusion that data analytics is something I wanted to 
      delve into, I asked myself so many questions like, why, where 
      and how would it be done because everyone first point-of-call 
      would be going online.I contacted a friend who did a course, 
      so I attended the masterclass and I was blown away. They have a structured curriculum, 
      you come to classes for 5 weeks and we have online sessions too, it is a total package.
      `,
    },

    {
      id: 4,
      linkedIn: "https://www.linkedin.com/in/vincent-ugochukwu-57aa90a8/",
      image: Testimony4,
      firstname: "Vincent",
      lastname: "Ugochukwu",
      company: "Digital Advertising Industry",
      testimony: `
      Practically speaking, I work with one of the biggest 
      communication brands in Nigeria and since I've taken this class,
       I have been able to see how data analytics is important to my job, 
       I have also been able to make recommendations within the organization. 
       It has also positioned me as a better professional in my workplace. 
       My opinion counts more than it used to. Data analytics for my industry 
       changes everything especially when you work with an agency and you 
       have a client who is always looking for a way to save money and save 
       time, so data analytics helps you have an advantage over your competition. 
      The facilitators simplify every process and I'll say that was what
      made the whole difference.
      `,
    },
    {
      id: 5,
      linkedIn: "",
      image: OladimejiImage,
      source: "google",
      firstname: "Oladimeji",
      lastname: "",
      company: "",
      testimony: `
      My experience in the Utiva Data Analysis class was highly rewarding and impactful. The program
      provided a well-structured learning that made complex data analysis concepts easy to understand
      for me even with my busy schedule, through the help of my trainers, Trainer Idara and the other
      trainer.
      `,
    },
    {
      id: 6,
      linkedIn: "",
      image: "",
      source: "google",
      firstname: "Mercy",
      lastname: "Shafe",
      company: "",
      testimony: `
      I don't have much to say, but I wanted to share that the journey so far has been smooth. Recently,
      though, the course is getting tougher, and I'm finding it a bit challenging to grasp everything all
      at once. I know I need to set aside quality practice time to fully understand. What I appreciate
      most about the Utiva team is their responsiveness and willingness to help. My trainer, Racheal,
      teaches our data analysis course, and she's been fantastic. She takes the time to ensure we
      understand and encourages us to ask questions. Sometimes I need her to re-explain a few things
      while I'm practicing, and even if she's not immediately available, she often gets back to me. I
      hope we'll have recordings of all the classes once we're finished, so I can revisit them and keep
      practicing until I feel confident.
      `,
    },
    {
      id: 7,
      linkedIn: "",
      image: "",
      source: "google",
      firstname: "Nnamdi",
      lastname: "Obinna Promise",
      company: "",
      testimony: `
      I have been learning at the Utiva Edtech Company for the past 6 months now. I enrolled in my first
      course with the company which was Data Analytics. My trainer in the Data Programme was Coach
      Rachael. The Utiva trainers, live coaches, the support team and even the community and network of
      other newbies and professionals in the company gave me an amazing learning experience which is the
      reason I am now currently enrolling in my second course with the company, which is the Business
      Analysis and Project Management Course where I have my trainer Miss Omobosola. So far, the learning
      experience has been nothing but amazing. The trainers and coaches take their time to teach in
      details and that is why it has been very easy for me to assimilate the lessons taught. I would
      definitely recommend Utiva to anyone who is finding his/her way into the Tech space either as a
      newbie or a professional. Utiva is the best place for you to be, grow and get connected to global
      opportunities.
      `,
    },
    {
      id: 8,
      linkedIn: "",
      image: LyndaImage,
      source: "google",
      firstname: "Lynda",
      lastname: "Chike Mozie",
      company: "",
      testimony: `
      I'm on the Data Analysis course. The trainer, Rachael, is very patient. She breaks it down and
      waits for everyone to catch up at each phase.
      `,
    },
    {
      id: 9,
      linkedIn: "",
      image: RasheedatImage,
      source: "google",
      firstname: "Rasheedat",
      lastname: "Ganiyu",
      company: "",
      testimony: `
      I really enjoyed my experience with Utiva's data analytics classes. The coaches were
      excellent—knowledgeable, supportive, and great at breaking down complex concepts. The courses were
      easy to understand and very well structured, making learning both smooth and enjoyable. I highly
      recommend Utiva to anyone looking to build strong data analytics skills.
      `,
    },
    {
      id: 10,
      linkedIn: "",
      image: FavourImage,
      source: "google",
      firstname: "Favour",
      lastname: "Bankong",
      company: "",
      testimony: `
      Learning Data Analytics with Utiva has been an amazing experience, and a huge part of the credit
      goes to my coach, Rachael. She explains every topic so clearly and makes each class engaging. I
      always look forward to our live sessions with her. Thank you, Coach Rachael, for making Data
      Analytics enjoyable and for always showing genuine care for your students' growth.
      `,
    },
    {
      id: 11,
      linkedIn: "",
      image: IjeaomaImage,
      source: "google",
      firstname: "Ijeaoma",
      lastname: "",
      company: "",
      testimony: `
      If you're looking for someone who truly understands data analytics and can teach it effectively,
      she's the one. Her energy, passion, and deep understanding of the field make her classes
      outstanding. Thank you Rachael, you rock!
      `,
    },
    {
      id: 12,
      linkedIn: "",
      image: TopeImage,
      source: "google",
      firstname: "Tope",
      lastname: "Eziekel",
      company: "",
      testimony: `
      My experience at Utiva has been enlightening. Our data analytics tutor Rachael Okolie and her team
      have taken the time to mentor us from the beginner stage and have been able to provide adequate
      answers to our questions. I can honestly say I have learnt a lot. Good work Utiva.
      `,
    },
    {
      id: 13,
      linkedIn: "",
      image: IyereImage,
      source: "google",
      firstname: "Iyere",
      lastname: "Cassandra",
      company: "",
      testimony: `
      I really appreciate Coach Rachael for the way she teaches. Her classes are always clear, detailed,
      and easy to follow. She makes learning data analytics enjoyable and takes time to explain
      everything well. I'm really grateful to have her as my coach at Utiva!
      `,
    },
    {
      id: 14,
      linkedIn: "",
      image: OlumideImage,
      source: "google",
      firstname: "Olumide",
      lastname: "Heric Ibideji",
      company: "",
      testimony: `
      Utiva is a great learning place. I am currently studying Data Analytics, September batch with them
      and it has been a great ride with our tutor Rachael. She's supportive both in and off the class
      section, she teaches calmly and her examples are easy for learners to quickly understand.
      `,
    },
    {
      id: 15,
      linkedIn: "",
      image: "",
      source: "google",
      firstname: "Chitex",
      lastname: "Iseoluwa",
      company: "",
      testimony: `
      Rachael is an outstanding Data Analytics trainer whose patience and clarity make learning both easy
      and enjoyable. She takes her time to explain complex concepts in a way that is simple, practical,
      and directly applicable to real-world situations. What stands out the most is how she makes Data
      Analytics relatable, using examples that connect to everyday life and the workplace. Her teaching
      style not only builds technical knowledge but also shows how analytics can be applied to solve real
      problems. I truly appreciate her dedication and the way she creates an engaging learning
      environment where no one is left behind.
      `,
    },
    {
      id: 16,
      linkedIn: "",
      image: KingsleyImage,
      source: "google",
      firstname: "Kingsley",
      lastname: "Umeh",
      company: "",
      testimony: `
      So far it has been an awesome learning experience in data analytics at Utiva. Thanks!
      `,
    },
    {
      id: 17,
      linkedIn: "",
      image: "",
      source: "google",
      firstname: "Ufuoma",
      lastname: "Dafe Emurotu",
      company: "",
      testimony: `
      My experience at Utiva has been awesome. From the live class session handled by Rachael Okolie to
      the study session on the Utiva platform, I am intrigued by Rachael's patience and knowledge of data
      analytics, how she patiently ensures everyone is carried along and understands each stage before
      proceeding to the next. Now I am better at Excel and able to use knowledge gained so far to get
      work done faster. It's great, I don't regret enrolling on Utiva.
      `,
    },
    {
      id: 18,
      linkedIn: "",
      image: "",
      source: "google",
      firstname: "Adebayo",
      lastname: "Oluwabumi",
      company: "",
      testimony: `
      Ayo is a teacher, he made data analysis very easy to handle, all sessions held by him were
      interesting. From showing how to navigate and handle tools to various designs one could explore, he
      made handling large data tiny and fun to do. His patience is top notch, I will surely recommend him
      to my friends, family and organization. Ayo is a pro teacher. God bless Ayo.
      `,
    },
    {
      id: 19,
      linkedIn: "",
      image: AjinifesinImage,
      source: "google",
      firstname: "Ajinifesin",
      lastname: "Afusat",
      company: "",
      testimony: `
      Utiva is one of the best tech schools and I am not even capping. From instructors that know their
      onions so well to the way Utiva designed their learning dashboard. All my instructors oversabi.
      From Aduragbemi to Faith and lastly to Ayo, I call them the "idan of data analytics".
      `,
    },
    {
      id: 20,
      linkedIn: "",
      image: TemioluwaImage,
      source: "google",
      firstname: "Temioluwa",
      lastname: "Aramide",
      company: "",
      testimony: `
      I am writing to express my sincere appreciation for the outstanding support I received from Mr. Ayo
      during my recent data analysis course. Mr. Ayo consistently went above and beyond in his role as a
      trainer. He demonstrated exceptional knowledge of the subject matter and, more importantly, a rare
      ability to explain complex concepts in a clear and understandable way. Whenever I struggled to
      grasp certain topics, he patiently guided me through them, ensuring I fully understood before
      moving forward. His dedication, approachability, and encouragement made a significant difference in
      my learning experience. Thanks to his support, I completed the course feeling more confident and
      capable in my data analysis skills. Trainers like Mr. Ayo are true tutors.
      `,
    },
    {
      id: 21,
      linkedIn: "",
      image: BashirImage,
      source: "google",
      firstname: "Bashir",
      lastname: "Oshiokpekhai",
      company: "",
      testimony: `
      I just had my first SQL session with Coach Ayobami Oje from Utiva as part of my data analytics
      course, and it was a great experience. He's knowledgeable, patient, and explains concepts clearly,
      making learning easy and engaging. I really enjoyed the session and look forward to more classes
      with him!
      `,
    },
    {
      id: 22,
      linkedIn: "",
      image: "",
      source: "google",
      firstname: "Elizabeth",
      lastname: "Lawal",
      company: "",
      testimony: `
      Trainer Rachel is calm in her teaching approach. Rachel Okolie is an exceptional Data Analytics
      coach whose professionalism, deep subject knowledge, and dedication to learner success are evident
      in every session. She explains complex analytical concepts in a clear and relatable way, ensuring
      that students of all backgrounds can grasp the material. Her patience in addressing questions,
      coupled with her structured teaching style, creates a supportive and engaging learning environment.
      Rachel consistently goes the extra mile to provide practical examples, actionable feedback, and
      relevant industry insights, making her training both impactful and applicable in real-world
      scenarios. She is a true asset to the Utiva learning community. Thank Rachel for making learning at
      Utiva easier.
      `,
    },
    {
      id: 23,
      linkedIn: "",
      image: FunmilolaImage,
      source: "google",
      firstname: "Funmilola",
      lastname: "Sansaya",
      company: "",
      testimony: `
      I had tried a few programmes on Data Analytics before Utiva and none of them offered the quality of
      learning at Utiva. I was amazed at the level of professionalism, thoroughness, patience, and
      kindness displayed by my first instructor, Coach Rachael Okolie. No question sounded stupid to her
      and she patiently carried everyone along, seeking to get regular feedback along the way. She even
      offered to help during the week when I was having problems with some Excel functions. Thank you,
      Coach Rachael. Thank you, Utiva.
      `,
    },
    {
      id: 24,
      linkedIn: "",
      image: AdeniyiImage,
      source: "google",
      firstname: "Adeniyi",
      lastname: "Agbede",
      company: "",
      testimony: `
      Last Sunday's session marked our second live class, and it was incredibly insightful—thanks to Ms.
      Rachael's clear, patient, and engaging teaching style. She took the time to ensure every student
      understood the concepts, never hesitating to revisit challenging points with calm and grace. Her
      depth of knowledge, coupled with her approachable demeanour, made the learning experience smooth
      and empowering. I'm truly grateful for the way she carries the entire class along, making sure no
      one is left behind. Thank you, Ms. Rachael.
      `,
    },
  ],

  portofolio: {
    title: "Build Solutions around Real-life Business Cases ",
    description: `
    Present everything you've learned with a real-world capstone project. 
    Every week in your data analytics classes, you'll be provided 
    with clear actionable steps to iteratively develop your project. 
    By the end of the course, you will have implemented each step of 
    the data analysis process, leveraging your knowledge of PostgreSQL and data visualization tools 
    to develop and derive a comprehensive solution of your work.
      `,

    name: "Patrick Ahamefule",
    image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Data Analytics Certification",
    description: `
    Upon completing Utiva's Data Analytics Bootcamp Course, you'll 
    receive an industry-recognized, professional Data Analytics 
    certification to share with your network and showcase all that 
    you've learned. Utiva certificates are formatted for sharing on LinkedIn.
      `,
  },

  // videoTestimonial: "https://www.youtube.com/embed/MUrpT0hlgc8",
  videoTestimonial: "https://www.youtube.com/embed/cT60Ka1J4ks",
  videoPreviewImage: DataAnalyticsPreview,

  otherCourses: [
    {
      id: 2,
      courseTitle: "Data Science Bootcamp",
      courseDescription: `This bootcamp program is designed for Africans in the 
      diaspora to master Data Science in 3 months and prepare 
      them for jobs in Data Science. Tools Include SQL, Excel, PowerBI & Python.`,
      courseUrl: "/courses/data-science-bootcamp",
    },
  ],
};
